import type { FC, MouseEvent, PropsWithChildren } from "react";
import { createContext, useContext, useMemo } from "react";

type QuickLinksConfiguration = {
  onClick: (ev: MouseEvent<HTMLAnchorElement>) => void;
};

const QuickLinksConfigurationContext = createContext<QuickLinksConfiguration>({ onClick: () => undefined });

export const QuickLinksProvider: FC<PropsWithChildren<QuickLinksConfiguration>> = ({ children, onClick }) => {
  const value = useMemo(() => ({ onClick }), [onClick]);

  return <QuickLinksConfigurationContext.Provider value={value}>{children}</QuickLinksConfigurationContext.Provider>;
};

export const useQuickLinksConfiguration = (): QuickLinksConfiguration => {
  return useContext(QuickLinksConfigurationContext);
};
